module.exports = __webpack_public_path__ + "static/media/status-ativado.bed5af48.svg";